import { MILESTONE_STATUS_LABEL } from "../../../src/shared/milestones";
import type { MilestoneReadiness, MilestoneStatus } from "../data/types";

/** Outcome colours. `planned` is deliberately quiet — it is the default state
 *  and says nothing yet; `missed` is the one that should catch the eye. */
const TONE: Record<MilestoneStatus, string> = {
  planned: "bg-gray-100 text-gray-700 border-[var(--border)]",
  hit: "bg-success-50 text-success-700 border-success-200",
  missed: "bg-error-50 text-error-700 border-error-200",
  cancelled: "bg-gray-50 text-[var(--text-3)] border-[var(--border)]",
};

export function MilestoneStatusBadge({ status }: { status: MilestoneStatus }) {
  return (
    <span className={`inline-flex h-6 w-fit items-center rounded-full border px-2 text-xs font-medium ${TONE[status]}`}>
      {MILESTONE_STATUS_LABEL[status]}
    </span>
  );
}

/**
 * Readiness in one phrase: "3 of 7 open", or "ready" when nothing is left.
 *
 * `openPastDate` is called out separately because it is the thing that goes
 * wrong quietly — work we have promised for after the date it is meant to
 * support. On 24 Sep that number was knowable in advance and invisible.
 */
export function readinessLabel(r: MilestoneReadiness): string {
  if (r.total === 0) return "No requests";
  if (r.open === 0) return "Ready";
  if (r.openPastDate > 0) return `${r.open} of ${r.total} open · ${r.openPastDate} due after`;
  return `${r.open} of ${r.total} open`;
}
